import { createStyles } from "@material-ui/core/styles";

const styles = (theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3),
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(2),
      },
    },
    container: {
      maxWidth: 800,
      margin: "0 auto",
    },
    title: {
      marginBottom: theme.spacing(4),
      color: theme.palette.primary.main,
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(3),
    },
    textField: {
      width: "100%",
    },
    button: {
      marginTop: theme.spacing(2),
      alignSelf: "flex-start",
    },
    loading: {
      display: "flex",
      justifyContent: "center",
      marginTop: theme.spacing(4),
    },
    error: {
      color: theme.palette.error.main,
      marginTop: theme.spacing(2),
    },
    success: {
      color: theme.palette.success.main,
      marginTop: theme.spacing(2),
    },
  });

export default styles;
